import { css } from 'lit';

import { nsReducedMotionStyles } from './ns-motion-styles.js';

export const nsButtonStyles = css`
  wa-button {
    --wa-form-control-height: var(--ns-button-height, 26px);
    --wa-form-control-border-radius: var(--wa-border-radius-pill);
    --wa-form-control-border-width: 0;
    --wa-font-weight-action: 500;
    --wa-button-transform-active: none;
    --wa-focus-ring: solid 2px var(--wa-color-focus);
    --wa-focus-ring-offset: 2px;

    display: inline-flex;
    vertical-align: top;

    border-radius: var(--wa-form-control-border-radius);

    font-size: var(--wa-font-size-s);
  }

  wa-button::part(base) {
    min-width: var(--ns-button-min-width, 64px);
    padding: var(--ns-button-padding, var(--wa-space-xs));

    line-height: 1.5;
  }

  wa-button::part(label) {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 100%;

    text-align: left;
  }

  wa-button[appearance='outlined'] {
    --wa-form-control-border-width: 1px;
  }

  wa-button[appearance='plain']::part(base) {
    color: inherit;
  }
  wa-button[appearance='plain']::part(base):hover {
    background-color: color-mix(in srgb, currentColor 8%, transparent);
  }

  wa-button[variant='success'],
  wa-button[variant='brand'] {
    font-size: var(--wa-font-size-m);
  }

  /* Figma's small purple pills ("View All", "More") */
  wa-button[size='s'] {
    --ns-button-height: 18px;
    --ns-button-min-width: 0;
    --ns-button-padding: 0 var(--wa-space-xs);

    font-size: var(--wa-font-size-3xs);
  }

  wa-button.white {
    --wa-color-fill-loud: var(--primary-card-background-color);
    --wa-color-on-loud: var(--secondary-text-color);
  }

  wa-button.black-bg {
    --wa-focus-ring: solid 2px var(--ns-theme-white);
  }

  wa-button.raised::part(base) {
    box-shadow: var(--ns-elevation-2);
    transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  wa-button.raised:hover::part(base),
  wa-button.raised:focus-within::part(base) {
    box-shadow: var(--ns-elevation-4);
  }
  wa-button.raised:active::part(base) {
    box-shadow: var(--ns-elevation-8);
  }
  wa-button.raised[disabled]::part(base) {
    box-shadow: none;
  }

  wa-button.card-button {
    --ns-button-height: 25px;

    font-size: var(--wa-font-size-xs);
  }

  wa-button.onboarding {
    --wa-color-fill-loud: var(--ns-theme-purple);
    --wa-color-on-loud: var(--primary-text-color);
    --wa-form-control-border-radius: var(--wa-border-radius-pill);
    --ns-button-height: auto;
    --ns-button-min-width: 40px;
    --ns-button-padding: var(--wa-space-xs);

    font-size: var(--wa-font-size-xs);
  }
  wa-button.onboarding::part(base) {
    line-height: 1;
  }
  wa-button.onboarding[disabled] {
    --wa-color-fill-loud: var(--ns-theme-grey-mid);
  }

  wa-button.icon-button {
    --icon-height: 1.5em;
    --icon-width: 1.5em;
    --ns-button-padding: 0.5em;
    --ns-button-height: auto;
    --ns-button-min-width: auto;
  }
  wa-button.icon-button::part(base) {
    overflow: hidden;
  }
  wa-button.icon-button.circle {
    --wa-form-control-border-radius: 50%;
  }

  @media (max-width: 576px) {
    wa-button.card-button,
    wa-button[variant='success'],
    wa-button.onboarding {
      font-size: var(--wa-font-size-3xs);
    }
  }

  ${nsReducedMotionStyles}
`;
